import { styled } from '@mui/material';
import type { ButtonProps } from '@mui/material';
import { FC } from 'react';
import { Button } from '@/components/button/button';

export const InlineButton: FC<ButtonProps> = styled(Button)(({ theme }) => ({
  border: 'none',
  padding: theme.spacing(0.5, 1),
  minWidth: 'auto',
  disableRipple: true,
  '&.MuiButton-text': {
    padding: theme.spacing(0.25, 0.75),
  },
}));
